import { createApp } from 'vue'
import App from './App.vue'
import AOS from 'aos'
//import 'aos/dist/aos.css'
//import router from './router'

//createApp(App).use(router).mount('#app')
createApp(App).use(AOS.init({
    easing: 'ease-out-back',
    duration: 1000
})).mount('#app')
